import {
  Button,
  Col,
  Dropdown,
  Form,
  Input,
  InputNumber,
  Modal,
  Popover,
  Row,
  Space,
  Table,
  Tag,
  Typography,
  message,
} from "antd";
import React, { useEffect, useState, useMemo } from "react";
import { MAIN_URL } from "../../Constants";
import { useProducts } from "../Params/Products/ProductStore";
import {
  SearchOutlined,
  AppstoreOutlined,
  FormOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import { usePos } from "./PosStore";
import axios from "axios";
import css from "./Pos.module.css";
import ShopRegister from "./ShopRegister";
import Stopwatch from "./StopWatch";
import emptyimg from "./../../assets/images/emptyimage.jpg";
import ParamsForm from "./ParamsForm";
import Itog from "./elements/Itog";

const sum = (v) => Number(v || 0).toLocaleString("ru-RU").replace(/,/g, " ");

const qualityLabel = (q) =>
  q === "1" ? "Original" : q === "2" ? "Podoriginal" : "Xitoy poddelka";

function Pos() {
  const { searchItem, sitems, scolumns, selected, setSelected, possendData } =
    usePos();
  const { fetchProducts, vrs } = useProducts();
  const shop_id = localStorage.getItem("shop_id");
  const [kassaStatus, setKassaStatus] = useState(true);
  const [vmodal, setVmodal] = useState(false);
  const [posVariants, setPosVariants] = useState([]);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  const handleVariants = (prd) => {
    const sid = localStorage.getItem("shop_id") || "null";
    axios
      .get(`/pos/variations/${sid}/${prd.id}`)
      .then((res) => setPosVariants(res.data))
      .catch(() => setPosVariants([]));
    setVmodal(true);
  };

  // Do'konda yetmagan tovarni ASOSIY SKLADDAN so'rash (transfer so'rovi)
  const requestFromMain = (item, count) => {
    const sid = localStorage.getItem("shop_id");
    if (!sid) {
      message.warning("Avval kassani (do'konni) tanlang");
      return;
    }
    axios
      .post("perenos", {
        vr_id: item.id,
        count,
        outcome: "Sklad",
        income: sid,
        respondent_out: 0,
        respondent_in: Number(sid),
        status: 1,
      })
      .then(() => message.success("Asosiy skladdan so'rov yuborildi"))
      .catch(() => message.error("So'rov yuborishda xatolik"));
  };

  const dropdownItems = useMemo(() => {
    return sitems.map((item) => ({
      key: item.id,
      label: (
        <div className={css.searchOption}>
          <span>
            {item.product}{" "}
            <span style={{ color: "var(--text-muted)" }}>{item.sku}</span>
          </span>
          <span>
            <Tag color={Number(item.shopcount) > 0 ? "green" : "red"} style={{ marginInlineEnd: 4 }}>
              Do'kon: {item.shopcount}
            </Tag>
            <Tag color="blue" style={{ marginInlineEnd: 0 }}>
              Asosiy: {item.maincount}
            </Tag>
          </span>
        </div>
      ),
      onClick: () => setSelected(item),
    }));
  }, [sitems, setSelected]);

  useEffect(() => {
    if (!shop_id) {
      setKassaStatus(true);
      return;
    }
    axios
      .get("checkregister/" + shop_id)
      .then((data) => setKassaStatus(data.data.status !== "open"))
      .catch(() => setKassaStatus(true));
  }, [shop_id]);

  const returnpay = Number(possendData.returnpay || 0);

  return (
    <div className={css.posRoot}>
      {/* ---- Variantlar modali ---- */}
      <Modal
        open={vmodal}
        footer={false}
        title="Variantni tanlang"
        width="80%"
        onCancel={() => setVmodal(false)}
      >
        <div className={css.variantGrid}>
          {posVariants.map((item) => (
            <div
              key={item.id}
              className={css.variantCard}
              onClick={() => {
                setSelected(item);
                setVmodal(false);
              }}
            >
              <img
                className={css.variantThumb}
                alt={item.product}
                src={item.img ? MAIN_URL + "/" + item.img : emptyimg}
              />
              <div className={css.variantBody}>
                <div className={css.variantTop}>
                  <div className={css.variantTitle}>
                    <Typography.Text strong>
                      {item.product} - {item.sku}
                    </Typography.Text>
                    <div className={css.variantMeta}>
                      {item.country} | {item.manufacturer}
                    </div>
                  </div>
                  <Tag
                    style={{
                      marginInlineEnd: 0,
                      backgroundColor: item.color_code,
                      color: "#fff",
                      border: "none",
                    }}
                  >
                    {item.color}
                  </Tag>
                </div>

                <Space size={[4, 4]} wrap style={{ marginTop: 10 }}>
                  <Tag color={Number(item.shopcount) > 0 ? "green" : "red"} style={{ marginInlineEnd: 0 }}>
                    Do'kon: {item.shopcount} ta
                  </Tag>
                  <Tag color="gold">Asosiy sklad: {item.maincount} ta</Tag>
                  <Tag color="blue">{qualityLabel(item.quality)}</Tag>
                  <Tag>{item.b_u === "1" ? "Ishlatilgan" : "Yangi"}</Tag>
                </Space>

                <div className={css.priceBox}>
                  <span>{sum(item.price_uzs)} so'm</span>
                  <span>{item.price_usd} $</span>
                </div>

                <div style={{ marginTop: 8 }} onClick={(e) => e.stopPropagation()}>
                  <Popover
                    trigger="click"
                    title="Asosiy skladdan nechta so'raysiz?"
                    content={
                      <Form layout="inline" onFinish={(v) => requestFromMain(item, v.count)}>
                        <Form.Item name="count" initialValue={1} rules={[{ required: true, message: "Soni" }]}>
                          <InputNumber min={1} max={Number(item.maincount)} />
                        </Form.Item>
                        <Button htmlType="submit" type="primary" size="small">
                          So'rash
                        </Button>
                      </Form>
                    }
                  >
                    <Button size="small" block disabled={Number(item.maincount) <= 0}>
                      Asosiy skladdan so'rash ({item.maincount})
                    </Button>
                  </Popover>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Modal>

      {kassaStatus && <ShopRegister setKassaStatus={setKassaStatus} />}
      {!kassaStatus && <Stopwatch setKassaStatus={setKassaStatus} />}

      <Row gutter={[16, 16]}>
        {/* ---- Chap: buyurtma parametrlari ---- */}
        <Col xs={24} lg={6}>
          <div className={css.panel}>
            <div className={css.panelHeader}>
              <h3 className={css.panelTitle}>
                <FormOutlined /> Buyurtma parametrlari
              </h3>
            </div>
            <div className={css.panelBody}>
              <ParamsForm />
            </div>
          </div>
        </Col>

        {/* ---- O'rta: qidiruv + savat + yakun ---- */}
        <Col xs={24} lg={12}>
          <div className={css.panel}>
            <div className={css.panelHeader}>
              <div className={css.searchRow}>
                <Dropdown
                  menu={{ items: dropdownItems }}
                  open={dropdownItems.length ? undefined : false}
                  trigger={["click"]}
                >
                  <Input
                    size="large"
                    allowClear
                    prefix={<SearchOutlined style={{ color: "var(--text-muted)" }} />}
                    placeholder="Tovar nomi / SKU / kod bo'yicha qidiring..."
                    onChange={(e) => searchItem(e.target.value)}
                  />
                </Dropdown>
              </div>
            </div>

            <div className={css.panelBodyFlush}>
              {selected.length ? (
                <Table
                  columns={scolumns}
                  dataSource={selected}
                  rowKey="id"
                  size="small"
                  pagination={false}
                  scroll={{ y: "calc(100vh - 430px)" }}
                />
              ) : (
                <div className={css.cartEmpty}>
                  <ShoppingCartOutlined />
                  <div>Savat bo'sh — mahsulot qo'shish uchun qidiring yoki o'ngdan tanlang</div>
                </div>
              )}
            </div>

            <div className={css.panelFooter}>
              <Itog />
              <div className={`${css.returnPay} ${returnpay < 0 ? css.negative : ""}`}>
                <span>Qaytim</span>
                <span>{sum(returnpay)} so'm</span>
              </div>
            </div>
          </div>
        </Col>

        {/* ---- O'ng: mahsulotlar ---- */}
        <Col xs={24} lg={6}>
          <div className={css.panel}>
            <div className={css.panelHeader}>
              <h3 className={css.panelTitle}>
                <AppstoreOutlined /> Mahsulotlar
              </h3>
              <Tag>{vrs.length}</Tag>
            </div>
            <div className={css.panelBody}>
              <div className={css.productGrid}>
                {vrs.map((item) => (
                  <div
                    key={item.id}
                    className={css.productCard}
                    onClick={() => handleVariants(item)}
                  >
                    <span
                      className={`${css.stockBadge} ${
                        item.count > 0 ? css.inStock : css.outStock
                      }`}
                    >
                      {item.count}
                    </span>
                    <img
                      className={css.productThumb}
                      alt={item.nameuz}
                      src={item.img ? MAIN_URL + "/" + item.img : emptyimg}
                    />
                    <div className={css.productName}>{item.nameuz}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Pos;
